<template>
  <div>
    <!-- BEGIN: Modal Toggle -->
    <div class="text-center">
      <a
        class="btn btn-primary"
        data-toggle="modal"
        data-target="#edit-step1-modal"
        @click="openEditModal"
      >
        <Edit2Icon class="h-3 w-3 mr-1" />
        แก้ไข
      </a>
    </div>
    <!-- END: Modal Toggle -->
    <!-- BEGIN: Modal Content -->
    <div id="edit-step1-modal" class="modal" tabindex="-1" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <a data-dismiss="modal" href="javascript:;" @click="cancelModalForm">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              แก้ไขข้อมูล{{stepEdit}}
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
             <Step1 :is-modal="true" :cancel-modal="cancelData" :open-modal="openModalStatus" :edit-data="editData" @update-state="updateChange" @cancel-button="cancelModalForm"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Modal Content -->
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue'
import Step1 from "@/components/member-wizard/step-1/index.vue"

export default defineComponent({
  props:{
    stepEdit: {
      type: String
    },
    editData: {
      type: Object
    }
  },
  components:{
    Step1
  },
  setup(props,{emit}) {
    const cancelData = ref(false)
    const openModalStatus = ref(false)
    function updateChange(){
      emit('updateProfile')
    }
    function cancelModalForm(){
      cancelData.value = true
      openModalStatus.value = false
    }
    function openEditModal(){
      openModalStatus.value = true
      cancelData.value = false
    }
    return {
      updateChange,
      cancelModalForm,
      cancelData,
      openEditModal,
      openModalStatus
    }
  },
})
</script>

